export default __webpack_public_path__ + "static/media/Facebook.4aa48664.svg";